import { readContract } from '@wagmi/core'
import { VaultViewerAbi } from 'abis/VaultViewerAbi'
import { atom } from 'jotai'
import { wagmiConfig } from 'services/wallet/chains'
import { Address, zeroAddress } from 'viem'
import { createAtomsWithQuery } from '../atomic-factory'
import { QUERY_REBALANCE_STATUS } from '../keys'
import { vaultViewers } from '../product-v2/redeem/configs'
import { FAST_REFETCH_INTERVAL } from '../refetch-intervals'
import { RebalanceStatusRequestAtoms } from './model'

const rebalanceStatusQuery = async <T>({
  queryKey: [, address],
}: {
  queryKey: [string, Address]
}) => {
  const rebalancing = await readContract(wagmiConfig, {
    address: vaultViewers[wagmiConfig.getClient().chain.id],
    abi: VaultViewerAbi,
    functionName: 'rebalancingFlags',
    args: [address],
  })
  return (rebalancing !== 0n) as T
}

export const rebalanceStatusAtomsFactory = () => {
  const indexAddressAtom = atom<Address>(zeroAddress)

  const mainProperties = createAtomsWithQuery<boolean, Address, null, null, [string, Address]>(
    { first: indexAddressAtom },
    QUERY_REBALANCE_STATUS,
    rebalanceStatusQuery<boolean>,
    FAST_REFETCH_INTERVAL,
  )

  return { indexAddress: indexAddressAtom, ...mainProperties } as RebalanceStatusRequestAtoms
}
